import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import classNames from "classnames";

import styles from "./WaffyBankInfoModal.module.scss";
import PrimaryButton from "../../../components/common/PrimaryButton";

interface Props {
  open: boolean;
  onClose: () => void;
}

const WaffyBankInfoModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(-1);

  const data = [
    {
      title: t("lbl_add_bank_account_written_bank_name"),
      value: t("lbl_development_bank"),
    },
    {
      title: t("lbl_add_bank_account_user_name"),
      value: t("lbl_waffy_company"),
    },
    {
      title: t("IBAN"),
      value: "SA1880000609608018999883",
    },
  ];

  const copyText = useCallback(async (value: string, index: number) => {
    try {
      await navigator?.clipboard?.writeText(value);
      setSelected(index);
      setTimeout(() => setSelected(-1), 2000);
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.container_wrapper}>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <p className={styles.title}>{t("lbl_waffy_bank_info")}</p>
        <div className={styles.content}>
          {data.map((item, index) => (
            <div
              key={index}
              onClick={() => copyText(item.value, index)}
              className={styles.section}>
              <div>
                <img
                  alt="copy"
                  src={
                    selected === index
                      ? "/assets/images/svg/tick.svg"
                      : "/assets/images/svg/copy-icon.svg"
                  }
                />
                <p className={classNames("ml2", "p2")}>{item.value}</p>
              </div>
              <p className={classNames("g600", "p2")}>{item.title}</p>
            </div>
          ))}
        </div>
        <PrimaryButton
          onClick={onClose}
          style={{
            width: "100%",
            marginTop: "16px",
            height: "44px",
            borderRadius: "8px",
            textAlign: "center",
            whiteSpace: "nowrap",
            fontSize: "14px",
            lineHeight: "100%",
            fontWeight: 500,
            backgroundColor: "#0d44ad",
          }}>
          {t("lbl_close")}
        </PrimaryButton>
      </Box>
    </Modal>
  );
};

export default WaffyBankInfoModal;
